import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";
import ImageFreeCropper from "../crop_image/ImageFreeCropper";

function PelaporanAdd() {
    const navigate = useNavigate();

    const [formValue, setFormValue] = useState({
        foto_cover: null,
        foto_wbs: null,
        dokumen: null,
        deskripsi: "",
    });

    const [preview, setPreview] = useState({
        foto_cover: null,
        foto_wbs: null,
        dokumen: null,
    });

    const [cropData, setCropData] = useState({
        isOpen: false,
        imageSrc: null,
        imageType: "",
    });

    const [croppedImage, setCroppedImage] = useState(null);

    // === OPEN IMAGE CROPPER ===
    const openCropper = (file, imageType) => {
        const reader = new FileReader();
        reader.onload = () => {
            setCropData({
                isOpen: true,
                imageSrc: reader.result,
                imageType,
            });
        };
        reader.readAsDataURL(file);
    };

    const closeCropper = () => {
        setCropData({
            isOpen: false,
            imageSrc: null,
            imageType: "",
        });
        setCroppedImage(null);
    };

    const applyCrop = () => {
        if (croppedImage instanceof Blob) {
            const blobUrl = URL.createObjectURL(croppedImage);

            setFormValue((prev) => ({
                ...prev,
                [cropData.imageType]: new File([croppedImage], `${cropData.imageType}.jpg`, {
                    type: "image/jpeg",
                }),
            }));

            setPreview((prev) => ({
                ...prev,
                [cropData.imageType]: blobUrl,
            }));
        } else {
            console.warn("⚠️ Cropped image belum berupa Blob");
        }

        closeCropper();
    };

    // === HANDLE HASIL CROP ===
    const handleCropped = (file, previewUrl) => {
        setFormValue((prev) => ({
            ...prev,
            [cropData.imageType]: file,
        }));

        setPreview((prev) => ({
            ...prev,
            [cropData.imageType]: previewUrl,
        }));

        closeCropper();
    };

    // === HANDLE INPUT CHANGE ===
    const handleChange = (event) => {
        const { name, value, files } = event.target;

        if (files && files.length > 0) {
            const file = files[0];

            // kalau file PDF → langsung simpan, gak lewat cropper
            if (name === "dokumen") {
                const blobUrl = URL.createObjectURL(file);
                setFormValue((prev) => ({ ...prev, dokumen: file }));
                setPreview((prev) => ({ ...prev, dokumen: blobUrl }));
                return;
            }

            // kalau image → buka cropper
            openCropper(file, name);
        } else {
            setFormValue((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    // === HANDLE SUBMIT ===
    const handleSubmit = async (event) => {
        event.preventDefault();

        if (
            !formValue.foto_wbs ||
            !formValue.dokumen ||
            !formValue.deskripsi
        ) {
            Swal.fire({
                title: "Error",
                text: "Semua field harus diisi",
                icon: "error",
            });
            return;
        }

        const formData = new FormData();
        formData.append("foto_cover", formValue.foto_cover);
        formData.append("foto_wbs", formValue.foto_wbs);
        formData.append("dokumen", formValue.dokumen);
        formData.append("deskripsi", formValue.deskripsi);

        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            await axios.post(
                `${process.env.REACT_APP_API_URL}/pelaporan/createPelaporan`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        authorization: token,
                    },
                }
            );

            Swal.fire({
                title: "Success",
                text: "Data berhasil ditambah",
                icon: "success",
            });
            navigate("/pelaporan");
        } catch (error) {
            const msg = error.response?.data?.message || "Data gagal ditambah";
            Swal.fire({
                title: "Error",
                text: msg,
                icon: "error",
            });
        }
    };

    // === RENDER ===
    return (
        <div className="wrappern">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">Pelaporan</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Tambah Pelaporan</h3>
                                    </div>

                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            {/* Foto Cover */}
                                            <div className="form-group">
                                                <label>Foto Banner</label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    name="foto_cover"
                                                    accept="image/*"
                                                    onChange={handleChange}
                                                />
                                                {preview.foto_cover && (
                                                    <img
                                                        src={preview.foto_cover}
                                                        alt="Preview Cover"
                                                        style={{
                                                            maxWidth: "200px",
                                                            marginTop: "10px",
                                                            borderRadius: "5px",
                                                        }}
                                                    />
                                                )}
                                            </div>

                                            {/* Foto WBS */}
                                            <div className="form-group">
                                                <label>Foto WBS</label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    name="foto_wbs"
                                                    accept="image/*"
                                                    onChange={handleChange}
                                                />
                                                {preview.foto_wbs && (
                                                    <img
                                                        src={preview.foto_wbs}
                                                        alt="Preview WBS"
                                                        style={{
                                                            maxWidth: "200px",
                                                            marginTop: "10px",
                                                            borderRadius: "5px",
                                                        }}
                                                    />
                                                )}
                                            </div>

                                            {/* Dokumen PDF */}
                                            <div className="form-group">
                                                <label>Dokumen (PDF)</label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    name="dokumen"
                                                    accept="application/pdf"
                                                    onChange={handleChange}
                                                />
                                                {formValue.dokumen && (
                                                    <div className="mt-2">
                                                        <p className="mb-1">
                                                            File: <b>{formValue.dokumen.name}</b>
                                                        </p>
                                                        <a
                                                            href={preview.dokumen}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-sm btn-outline-info"
                                                        >
                                                            Lihat Dokumen
                                                        </a>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Deskripsi */}
                                            <div className="form-group">
                                                <label>Deskripsi</label>
                                                <textarea
                                                    className="form-control"
                                                    name="deskripsi"
                                                    placeholder="Masukkan deskripsi"
                                                    value={formValue.deskripsi}
                                                    onChange={handleChange}
                                                    rows="3"
                                                />
                                            </div>

                                            {/* Tombol Aksi */}
                                            <div className="mt-3">
                                                <button type="submit" className="btn btn-info">
                                                    Simpan
                                                </button>
                                                <Link to="/pelaporan">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary ml-2"
                                                    >
                                                        Batal
                                                    </button>
                                                </Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* Modal Cropper */}
            {cropData.isOpen && (
                <ImageFreeCropper
                    imageSrc={cropData.imageSrc}
                    setCroppedImage={handleCropped}
                    onClose={closeCropper}
                />
            )}
        </div>
    );
}

export default PelaporanAdd;
